module.exports = __webpack_public_path__ + "static/img/1-神州数码.608b3ecd.png";